// Small logging helpers for frontend.
// They guard against missing console implementations and normalise usage.

function getConsoleMethod(fallback) {
  if (typeof console === 'undefined') {
    return null;
  }
  const method = console[fallback] || console.log;
  if (typeof method !== 'function') {
    return null;
  }
  return method.bind(console);
}

export function logWarn(message, details) {
  const fn = getConsoleMethod('warn');
  if (!fn) {
    return;
  }
  if (typeof details !== 'undefined') {
    fn(message, details);
  } else {
    fn(message);
  }
}

export function logError(message, details) {
  const fn = getConsoleMethod('error');
  if (!fn) {
    return;
  }
  if (typeof details !== 'undefined') {
    fn(message, details);
  } else {
    fn(message);
  }
}

